// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Insights_wrapper__tw5e5"};